/*
 * @Author: zhushitao
 * @Date: 2021-08-12 16:08:47
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-08-24 14:55:40
 * @Description:
 */
import { ENV } from '../constants/net';
import { Region } from '../constants/lang';
import store from '../store/cache';
import { is } from './index';

const API_PREFIX = '/api';
const API_ORIGINS = {
  [Region.cn]: {
    BOE: `https://ngcc-boe.bytedance.com`,
    PROD: `https://ngcc.bytedance.com`,
    TEST: `https://ngcc-test.bytedance.com`,
    PPE: `https://ngcc.bytedance.com`,
  },
  [Region.sg]: {
    BOE: `https://ngcc-cloud-oversea-boe.bytedance.net`,
    PROD: `https://ngcc.byteoversea.com`,
    TEST: `https://ngcc-cloud-oversea-boe.bytedance.net`,
    PPE: `https://ngcc.byteoversea.com`,
  },
};

export { API_ORIGINS, API_PREFIX };

// Determine the API BASE URL according to the environment
const getBaseUrl = (url: string) => {
  const prefix = url.indexOf('api') > 0 ? '' : API_PREFIX;
  const apiOrigin = store.get('apiOrigin');
  const region = store.get('region') as Region.cn | Region.sg;
  const env: ENV = store.get('env') || 'BOE';

  if (apiOrigin !== undefined) {
    return `${apiOrigin}${prefix}`;
  }

  if (env.toUpperCase() === 'PROD') {
    return `${API_ORIGINS[region].PROD}${prefix}`;
  }

  if (env.toUpperCase() === 'PPE') {
    return `${API_ORIGINS[region].PPE}${prefix}`;
  }

  if (env.toUpperCase() === 'BOE') {
    return `${API_ORIGINS[region].BOE}${prefix}`;
  }
};

// Judging null value
const isParamEmpty = (value: any) => {
  return (
    value === '' ||
    value === undefined ||
    value === null ||
    (Array.isArray(value) && !value.length)
  );
};

// Clear null value
const clearParams = (params: any) => {
  if (!params || !is.object(params)) {
    return params;
  }

  const o: { [key: string]: any } = {};

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (!isParamEmpty(value)) {
      o[key] = value;
    }
  });

  return o;
};

// Generate qs
const querystring = (params: { [key: string]: any } = {}, prefix = true) => {
  const qs: string[] = [];

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (!isParamEmpty(value)) {
      qs.push(`${key}=${value}`);
    }
  });

  if (!qs.length) {
    return '';
  }

  return prefix ? `?${qs.join('&')}` : qs.join('&');
};

// Get the full api address
const getApiUrl = (url: string, params: any) => {
  const qs = querystring(params);
  return `${getBaseUrl(url)}${url}`;
};

export { clearParams, getApiUrl, querystring };
